export default {
  headers: {
    edit_time: 'Edytuj czas',
    create_time: 'Utwórz czas',
  },
  labels: {
    select_all: 'Zaznacz wszystkie',
  },
  buttons: {
    add_opening_time: 'Dodaj godzinę otwarcia',
    add: 'Dodaj',
    cancel: 'Anuluj',
  },
};
